import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";
import moment from "moment";
import FileUploaderTne from "../../../../components/FileUploaderTne";
import { GetServiceCaller } from "../../../../services/serviceCaller";

const ViewTnE = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("View TnE"));
  }, []);

  const initialFormData = {
    ID: "",
    ProjectID: "",
    FromDate: "",
    ToDate: "",
    AdvanceAmountUSD: 0,
    ExchangeRateUSD: 0,
    AdvanceAmountINR: 0,
    ExchangeRateINR: 0,
    AdvanceAmountBASE: 0,
    attachFile: "TnE_Deloitte_Manish_1710767805.xls",
    BalanceAmountBASE: 0,
    ApprovedAmountBASE: 0,
    AdjustAmountBASE: 0,
    MonthID: 0,
    ActionRemark: "",
    EmployeeID:"",
    FileName: "",
    ApplicationStatus_123: "",
    reimbursementLines: [
      {
        LineNo: 1,
        OnDate: "",
        CategoryID_168: "",
        SubCategoryID_SD168: "",
        Remark: "",
        SubCategory: "",
        AmountUSD: "",
        AmountINR: "",
        ApplicationStatus_123: "",
        VerificationRemark: "",
      },
    ],
  };
  const [formData, setFormData] = useState(initialFormData);
  const [projectList, setProjectList] = useState([]);
  const [categoryOpt, setCategoryOpt] = useState([]);
  const [descriptionOpt, setDescriptionOpt] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [rows, setRows] = useState([]);
  const [errors, setErrors] = useState([]);
  const [resumeFile, setResumeFile] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [FileName, setFileName] = useState([]);
  const [projectTXNs, setProjectTXNs] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [payrollList, setPayrollList] = useState([]);
  const [fileAttachment, SetFileAttachment] = useState([]);
  const [empList, setEmpList] = useState([]);

  useEffect(() => {
    if (id) {
      fetchTne(id);
    }
  }, []);

  const fetchTne = async (id) => {
    const response = await GetServiceCaller(
      `${API_URL}payroll/reimbursements/team-reimbursements/${id}`
    );
    if (response.status === 200) {
      const EmployeeDetail = response?.data?.data?.employee;
      const empOpt = EmployeeDetail.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setEmpList(empOpt);

      const attachment = response?.data?.data?.FilePath;
      SetFileAttachment(attachment);

      const listProject = response?.data?.data?.projectList;
      const projectOpt = listProject?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setProjectList(projectOpt);

      const status = response?.data?.data?.status;
      const statusOpt = status.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setStatusList(statusOpt);

      const payroll = response?.data?.data?.payrollMonths;
      const payrollOpt = payroll.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setPayrollList(payrollOpt);
      const fetchData = response?.data?.data?.tneList;
      const fetchLineData = response?.data?.data?.tneSubList;
      const Lines = fetchLineData.map((item) => ({
        ID: item.ID,
        TXNID: item.TXNID,
        LineNo: item.LineNo,
        OnDate: moment(item.OnDate).format("DD-MMM-YYYY"),
        CategoryID_168: item.CategoryID_168,
        SubCategoryID_SD168: item.SubCategoryID_SD168,
        Remark: item.Remark,
        AmountUSD: item.AmountUSD,
        ApplicationStatus_123: item.ApplicationStatus_123,
        VerificationRemark: item.VerificationRemark,
        AmountINR: item.AmountINR,
        SubCategory: item.SubCategory,
      }));

      const formDataEdit = {
        ID: fetchData?.ID,
        ProjectID: fetchData?.ProjectID,
        FromDate: moment(fetchData?.FromDate).format("DD-MMM-YYYY"),
        ToDate: moment(fetchData?.ToDate).format("DD-MMM-YYYY"),
        ActionRemark: fetchData?.ActionRemark,
        ApplicationStatus_123: fetchData?.ApplicationStatus_123,
        MonthID: fetchData?.MonthID,
        EmployeeID:fetchData?.EmployeeID,
        ExchangeRateUSD: fetchData?.ExchangeRateUSD,
        AdvanceAmountUSD: fetchData?.AdvanceAmountUSD,
        AdvanceAmountBASE: fetchData?.AdvanceAmountBASE,
        AdvanceAmountINR: fetchData?.AdvanceAmountINR,
        FileName: fetchData?.FileName,
        BalanceAmountBASE: fetchData?.BalanceAmountBASE,
        ApprovedAmountBASE: fetchData?.ApprovedAmountBASE,
        AdjustAmountBASE: fetchData?.AdjustAmountBASE,
        reimbursementLines: Lines,
      };
      setFormData(formDataEdit);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };

  useEffect(() => {
    if (formData?.ProjectID || formData?.EmployeeID) {
      fetchProjectDetails(formData?.ProjectID, formData?.EmployeeID);
    }
  }, [formData.ProjectID, formData?.EmployeeID]);

  const handleFile = (file) => {
    if (file) {
      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachFile: "",
      }));

      // Update form data and resume file state
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        attachFile: file,
      }));
      setResumeFile(file);
    } else {
      // Set an error message if file is invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachFile:
          "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };

  const fetchProjectDetails = async (selectedValue, empId) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/project/currency?ProjectID=${selectedValue}&EmployeeID=${empId}`
      );

      if (response.status === 200) {
        const data = response?.data?.data;

        const nonINRCurrencies = data?.filter(
          (item) => item.CurrencySymbol !== "Rs."
        );
        const Symbol = nonINRCurrencies?.map((item) => item.CurrencySymbol);
        setCurrencySymbol(Symbol);
        const projectTXNs = data.map((item) => item.TXNs);
        setProjectTXNs(projectTXNs);
      }
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const handleInputChange = (rowIndex, field, value) => {
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex][field] = value;
    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
  };

  const fetchTnE = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/new-TnE`
      );
      // Category Options
      const categoryList = response?.data?.data?.categoryList;
      const CategoryOptions = categoryList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setCategoryOpt(CategoryOptions);
    } catch (error) {
      console.error("Error fetching TnE:", error);
    }
  };

  useEffect(() => {
    fetchTnE();
  }, []);

  const fetchDescriptionAPI = async (selectedValue) => {
    try {
      const url = `${API_URL}payroll/reimbursements/get-category-list?CategoryID=${selectedValue.value}`;

      // Call the API using the custom service
      const response = await GetServiceCaller(url);
      const description = response?.data?.data;
      const descriptionOpt = description.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDescriptionOpt(descriptionOpt);
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };
  const handleChange = async (event, name = null) => {
    let value;
    if (name) {
      // If it's a Select component (with selectedOption)
      const selectedOption = event;
      value = selectedOption ? selectedOption.value : "";
      setSelectedProject(selectedOption); // Assuming you still want to set the selected project
    } else {
      // If it's an input field
      const { name: fieldName, value: fieldValue } = event.target;
      value = fieldValue;
    }

    setFormData((prevState) => ({
      ...prevState,
      [name || event.target.name]: value,
    }));
  };

  const handleSelect1Change = async (value, rowIndex) => {
    console.log("status", value);

    setRows(
      rows.map((r, i) => (i === rowIndex ? { ...r, select1: value } : r))
    );

    fetchDescriptionAPI(value);

    // Update CategoryID_168 in reimbursementLines, passing only the value
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex] = {
      ...updatedReimbursementLines[rowIndex],
      CategoryID_168: value.value,
    };
    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
  };

  // new code
  const handleCheckboxChange = (index, line, checked) => {
    const newSelectedRows = checked
      ? [...selectedRows, index]
      : selectedRows.filter((row) => row !== index);
    setSelectedRows(newSelectedRows);

    setFormData((prevData) => {
      const updatedLines = prevData.reimbursementLines.map(
        (line, lineIndex) => {
          if (lineIndex === index) {
            return {
              ...line,
              ApplicationStatus_123: checked,
            };
          }
          return line;
        }
      );

      return { ...prevData, reimbursementLines: updatedLines };
    });
  };

  const calculateApprovedAmount = () => {
    return selectedRows
      .reduce((total, index) => {
        const amount =
          parseFloat(formData?.reimbursementLines[index]?.AmountINR) || 0;
        return total + amount;
      }, 0)
      .toFixed(2);
  };

  const handleCancel = () => {
    const { state } = location;

    if (state && state.from) {
      navigate(state.from);
    } else {
      // Default fallback
      navigate("/default-route");
    }
  };

  const handleExport = (id) => {
    navigate(`/my-reimbursements/report/exportTne/${formData.ID}`);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <form>
            <div>
              <div className="row">
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      Project<span className="required">*</span>
                    </label>
                    <Select
                      value={projectList.find(
                        (opt) => opt.value === formData.ProjectID
                      )}
                      options={projectList}
                      name="ProjectID"
                      isDisabled
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      From Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      value={formData.FromDate}
                      name="FromDate"
                      id="FromDate"
                      isDisabled="true"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      To Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      value={formData.ToDate}
                      name="ToDate"
                      id="ToDate"
                      className="form-control red-datepicker"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>

            <hr class="border-2 border-top mt-0 border-black" />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                marginBottom: "10px",
              }}
            >
              {projectTXNs.map((txn, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#00C0EF",
                    padding: "2px",
                    borderRadius: "20px",
                    color: "white",
                  }}
                >
                  <span>
                    <div dangerouslySetInnerHTML={{ __html: txn }} />
                  </span>
                </div>
              ))}
            </div>
 <div className="table-responsive" style={{ overflowX: "auto" }}>
            <Table bordered rounded>
              <thead id="thcolor" className="text-center">
                <tr>
                  <td>#</td>
                  <td>Date<span className="required">*</span></td>
                  <td style={{width:"160px"}}>
                    Category<span className="required">*</span>
                  </td>
                  <td>
                    Description<span className="required">*</span>
                  </td>
                  <td>Remark</td>
                  <td style={{width:"120px"}}>
                    Amt. ({currencySymbol})<span className="required">*</span>
                  </td>
                  <td style={{width:"120px"}}>
                    Amt. (&#8377;)<span className="required">*</span>
                  </td>
                  <td style={{width:"120px"}}>Base Amt. (&#8377;)</td>
                  <td></td>
                  <td>Verification Remark</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-end">
                    <b>Advance Amt. :</b>
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="0.00"
                      disabled
                      className="form-control text-end"
                      name="AdvanceAmountUSD"
                      value={formData.AdvanceAmountUSD}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="0.00"
                      disabled
                      className="form-control text-end"
                      name="AdvanceAmountINR"
                      value={formData?.AdvanceAmountINR}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled
                      placeholder="0.00"
                      className="form-control text-end"
                      name="AdvanceAmountBASE"
                      value={formData?.AdvanceAmountBASE}
                    />
                  </td>
                </tr>
                {formData?.reimbursementLines?.map((line, index) => {
                  const exchangeRateUSD = formData?.ExchangeRateUSD || 0;
                  const calculatedAmountINR = parseFloat(
                    (line?.AmountUSD || 0) * exchangeRateUSD
                  ).toFixed(2);
                  return (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        <CustomDatePicker
                          readOnly
                          
                          value={line.OnDate}
                          name="OnDate"
                          id="OnDate"
                          className="form-control"
                          placeholderText="DD-MM-YYYY"
                        />
                      </td>
                      <td>
                        <Select
                          value={categoryOpt.find(
                            (opt) => opt.value === line.CategoryID_168
                          )}
                          isDisabled={true}
                          options={categoryOpt}
                          onChange={(value) =>
                            handleSelect1Change(value, index, "CategoryID_168")
                          }
                          name="CategoryID_168"
                        />
                      </td>
                      <td>
                        {/* <Select
                          value={descriptionOpt.find((opt) => opt.label === line.SubCategory)}
                          options={descriptionOpt}
                          // onChange={(value) => handleSelect2Change(value, index)}
                        /> */}
                        <input
                          type="text"
                          className="form-control"
                          disabled
                          value={line.SubCategory}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="Remark"
                          className="form-control text-end"
                          value={line.Remark}
                          disabled
                          onChange={(e) =>
                            handleInputChange(index, "Remark", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={line.AmountUSD}
                          disabled
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "AmountUSD",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={line.AmountINR}
                          disabled
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "AmountINR",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={
                            calculatedAmountINR != 0.0
                              ? calculatedAmountINR
                              : line.AmountINR
                          }
                          disabled
                          name="amtBase"
                        />
                      </td>
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="ApplicationStatus_123"
                          id={`flexSwitchCheckChecked-${index}`}
                          disabled
                          // checked={selectedRows.includes(index)}
                          checked={line.ApplicationStatus_123}
                          onChange={(e) =>
                            handleCheckboxChange(index, line, e.target.checked)
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="VerificationRemark"
                          id="VerificationRemark"
                          disabled
                          value={line.VerificationRemark}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "VerificationRemark",
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  );
                })}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-end">
                    <b>Total:</b>
                  </td>
                  <td className="text-end">
                    <div>
                      <div>
                        <b>
                          {formData?.reimbursementLines
                            ?.reduce(
                              (sum, line) =>
                                sum + (parseFloat(line.AmountUSD) || 0),
                              0
                            )
                            .toFixed(2)}
                        </b>
                      </div>
                    </div>
                    <div>
                      <p>(ER:{formData.ExchangeRateUSD})</p>
                    </div>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {formData?.reimbursementLines
                          ?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountINR) || 0),
                            0
                          )
                          .toFixed(2)}
                      </b>
                    </div>
                    <div>
                      <p>(ER:1.00)</p>
                    </div>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {(
                          formData?.reimbursementLines?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountUSD) || 0),
                            0
                          ) *
                            (parseFloat(formData.ExchangeRateUSD) || 0) +
                          formData?.reimbursementLines?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountINR) || 0),
                            0
                          )
                        ).toFixed(2)}
                      </b>
                    </div>
                    <div>
                      <p>(ER:1.00)</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td colspan="3" rowspan="3">
                    <div className="row mt-2">
                      <label className="col-sm-3 mt-2">
                        <b>Remarks</b>
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          type="text"
                          class="form-control"
                          id="ActionRemark"
                          aria-describedby="ActionRemark"
                          name="ActionRemark"
                          disabled
                          value={formData.ActionRemark}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <label className="col-sm-3 mt-2">
                      {/* <FileUploaderTne handleFile={handleFile} /> */}
                      <b>Attachment</b>
                      </label>
                      <div className="col-sm-9 mt-2 text-start">
                      <p>
                          <a target="_blank" href={fileAttachment}>
                            {FileName != "" ? FileName : formData?.FileName}
                          </a>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td colspan="2" rowspan="2">
                  {formData.BalanceAmountBASE >= 0 && (
                      <div className="d-flex gap-1 mt-2">
                        <div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsDeductFromSalary"
                            checked={formData.IsDeductFromSalary === 1}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                IsDeductFromSalary: e.target.checked ? 1 : 0,
                              })
                            }
                          />
                        </div>
                        <label className="col-sm-12">
                          <b>Deduct From Salary</b>
                        </label>
                      </div>
                    )}
                  </td>
                  <td colspan="2" rowspan="2">
                    <div className="row mt-2">
                      <label className="col-sm-6 mt-2">
                        <b>
                          Approved Amt. (&#8377;)
                          <span className="required">*</span>
                        </b>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          value={formData?.ApprovedAmountBASE}
                          placeholder="0.00"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <label className="col-sm-6 mt-2">
                        <b>Adjusted Amt. (&#8377;)</b>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          value={formData?.AdjustAmountBASE}
                          placeholder="0.00"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <label className="col-sm-6 mt-2">
                        <b>
                          Balance Amt. (&#8377;)
                          <span className="required">*</span>
                        </b>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          value={formData?.BalanceAmountBASE}
                          placeholder="0.00"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
</div>
            <div className="text-end">
              <div className="row mt-5">
                <div className="col-md-12">
                  <button className="cancel-btn me-2" onClick={handleCancel}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="custom-btn"
                    onClick={handleExport}
                  >
                    Export
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ViewTnE;
